import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLE_BY_PREFIX: ReadonlyArray<readonly [string, string]> = [
  ['/login', 'sherlock — please identify yourself'],
  ['/auth/callback', 'sherlock — verifying your credentials'],
  ['/insights', 'sherlock — detect, the game is afoot'],
  ['/issues/', 'sherlock — examining the evidence'],
  ['/issues', "sherlock — detect's curious incidents"],
  ['/investigate', 'sherlock — investigating detect'],
  ['/investigations/', 'sherlock — the case file'],
  ['/investigations', 'sherlock — past cases on detect'],
];

function titleFor(pathname: string): string {
  for (const [prefix, title] of TITLE_BY_PREFIX) {
    if (pathname === prefix || pathname.startsWith(prefix)) return title;
  }
  return 'sherlock';
}

export function useDocumentTitle(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = titleFor(pathname);
  }, [pathname]);
}
